import React from "react";

export const ArrowUpIcon = ({ width = 16, height = 16, color = "black", className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M11.3337 9.33333L8.00033 6L4.66699 9.33333"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
